import styled from 'styled-components';

import IconFontAnswer from '../../basic/IconFontAnswer';

export const Icon = styled(IconFontAnswer).attrs(props => ({
  unicode: 'f0e0',
  color: props.color || '#ffffff',
}))``;
